import React, { lazy, Suspense, useEffect, useMemo, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import * as urls from "../../utils/URLConst";
import makeRequest from "../../utils/makeRequest";
import { Button, Card, Col, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { handleLoader } from "../../redux/reducers/layout";
import toastNotify from "../../utils/ToastNotify";
import Loader from "../../componants/loader/Loader";
import { BiHomeAlt } from "react-icons/bi";
import SelectField from "../../componants/textField/SelectField";
import { Formik, Form } from "formik";

const ProductServiceTbl = lazy(() => import('../../contants/tables/ProductServiceDltTbl'));

const Products = () => {
  const [apidata, setApiData] = useState([]);

  const location = useLocation();
  const productData = location.state;
  const dispatch = useDispatch();
  const { state } = useLocation();
  const [selectedFilter, setSelectedFilter] = useState({
    productTypeValue: "",
    productTypeLabel: "All Products"
  });

  async function fetchProdcuServiceTable() {
    try {
      dispatch(handleLoader(true));
      const data = {
        FLAG: productData ? productData : "A",
      };
      const result = await makeRequest("POST", urls.getProductServiceTable, data, {});

      if (result.STATUS === "0") {
        const response = result.RESPONSE;

        const sortedData = response.sort((a, b) => {
          if (a.EXPIRING_FLAG === 'Y' && b.EXPIRING_FLAG !== 'Y') return -1;
          if (a.EXPIRING_FLAG !== 'Y' && b.EXPIRING_FLAG === 'Y') return 1;
          return 0;
        });

        setApiData(sortedData);
      } else {
        result.MESSAGE !== "Not found!" && toastNotify(result.MESSAGE, "error");
      }
    } catch (error) {
      // Ignore Case
    } finally {
      dispatch(handleLoader(false));
    }
  }

  useEffect(() => {
    fetchProdcuServiceTable();
  }, []);

  useMemo(() => {
    if (state) {
      setSelectedFilter(state);
    }
  }, [])

  return (
    <>
      <div className="container-xxl flex-grow-1 container-p-y">
        <div className="date-time container-top">
          <div>
            <span className="d-none d-md-inline"><BiHomeAlt />&nbsp;</span>
            <NavLink to="/dashboard" className="text-secondary d-none d-md-inline">
              Dashboard /
            </NavLink>
            <span className="navigation-header-text ps-1"> My Order</span>
          </div>
        </div>
        <Card className="mt-3">
          <Card.Body>
            <Formik
              initialValues={{
                productTypeValue: selectedFilter.productTypeValue,
                productTypeLabel: selectedFilter.productTypeLabel,
              }}
              onSubmit={(values) => setSelectedFilter(values)}
            >
              {({ setFieldValue, values }) => {
                return (
                  <Form>
                    <Row>
                      <Col md={3}>
                        <SelectField
                          name="product"
                          tabIndex={2}
                          options={[
                            { value: "", label: "All Products" },
                            { value: "Y", label: "Renewable Product" },
                            { value: "N", label: "Non-Renewable Product" },
                          ]}
                          required
                          placeholder="Product Type"
                          value={{
                            value: values.productTypeValue,
                            label: values.productTypeLabel
                          }}
                          onChange={(e) => {
                            setFieldValue("productTypeValue", e?.value);
                            setFieldValue("productTypeLabel", e?.label);
                          }}
                        />
                      </Col>
                      <Col md={3} className="mt-md-0 mt-3">
                        <Button
                          type="submit"
                          className="btn-sm"
                        >
                          Submit
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                );
              }}
            </Formik>

            <hr />

            <Suspense fallback={<Loader isLoader={true} />}>
              <ProductServiceTbl
                data={apidata.filter((items) => selectedFilter.productTypeValue !== "" ? items.ITEM_EXPIRE_FLG === selectedFilter.productTypeValue : items)}
                flag="M"
                height="auto"
                selectedFilter={selectedFilter}
              />
            </Suspense>
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export default Products;
